import { createSelector } from '@reduxjs/toolkit';

import { RootState } from 'redux/reducers/rootReducer';
import { isCorporateTASelector } from './authenticationSelectors';
import { getUnfilledSectionForMyProfile } from 'utils/accountUtils';

const myProfileSelector = (state: RootState) => state.account.myProfile;
const unfilledMyProfileSectionsSelector = createSelector(
  myProfileSelector,
  isCorporateTASelector,
  getUnfilledSectionForMyProfile,
);

const primaryContactsSelector = (state: RootState) =>
  state.account.primaryContacts;
const isPrimaryContactsLoadingSelector = (state: RootState) =>
  state.account.isPrimaryContactsLoading;

const supervisorSelector = (state: RootState) => state.account.supervisors;
const isSupervisorsLoadingSelector = (state: RootState) =>
  state.account.isSupervisorsLoading;

const timesheetApproversSelector = (state: RootState) =>
  state.account.timesheetApprovers;
const isTimesheetApproversLoadingSelector = (state: RootState) =>
  state.account.isTimesheetApproversLoading;

export {
  unfilledMyProfileSectionsSelector,
  primaryContactsSelector,
  supervisorSelector,
  timesheetApproversSelector,
  isPrimaryContactsLoadingSelector,
  isSupervisorsLoadingSelector,
  isTimesheetApproversLoadingSelector,
};
